import { RootStore } from "./RootStore";
import {
  getMachines,
  getMachine,
  createMachine,
  updateMachine,
  removeBoardOnMachine,
  changeBoard,
  getChangeBoard,
  getChangeBoards,
} from "../vendor";
import { Status } from "../vendor/types";

export class MachineStore {
  protected rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  public getMachine = async (id: number) => {
    try {
      return await getMachine(id);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a máquina.",
        "error"
      );
      return null;
    }
  };

  public getMachines = async (
    where: {
      onlyNoApply?: boolean;
      onlyApply?: boolean;
      textSearch?: string;
      partnerId?: string;
      gameId?: string;
      all?: boolean;
    },
    limit?: number,
    offset?: number
  ) => {
    try {
      return await getMachines(where, limit, offset);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a lista das máquinas.",
        "error"
      );
      return null;
    }
  };

  public createMachine = async (data: {
    partnerId: number;
    boardId: number;
    partnerName: string;
    obs: string;
    machineCreatedDate: Date;
    status: Status;
  }) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      const machine = await createMachine(data);

      this.rootStore.generalStore.setShowLoading(false);

      return machine;
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível montar essa máquina.",
        "error"
      );
      this.rootStore.generalStore.setShowLoading(false);

      return null;
    }
  };

  public updateMachine = async (
    data: {
      partnerId?: number;
      obs?: string;
      partnerName?: string;
      machineCreatedDate?: Date;
      status?: Status;
    },
    id: number
  ) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      await updateMachine(data, id);

      this.rootStore.routerStore.push("/dashboard/machines");
      this.rootStore.generalStore.showSnackbar(
        "Máquina editada com sucesso!",
        "success"
      );
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível editar essa máquina.",
        "error"
      );
    } finally {
      this.rootStore.generalStore.setShowLoading(false);
    }
  };

  public removeBoardOnMachine = async (id: number) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      await removeBoardOnMachine(id);
      this.rootStore.generalStore.showSnackbar(
        "Placa removida com sucesso!",
        "success"
      );

      this.rootStore.generalStore.setShowLoading(false);

      return true;
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível remover essa placa.",
        "error"
      );

      this.rootStore.generalStore.setShowLoading(false);

      return false;
    }
  };

  public changeBoard = async (
    data: {
      newBoardId: number;
      obs: string;
      changeDate: Date;
      reasonId: number;
      meterCurrentEntry: number;
      meterCurrentExit: number;
    },
    id: number
  ) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      const changeBoardPayload = await changeBoard(data, id);

      this.rootStore.generalStore.showSnackbar(
        "Troca de placa realizada com sucesso.",
        "success"
      );

      this.rootStore.generalStore.setShowLoading(false);

      return changeBoardPayload;
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível realizar a troca de placa.",
        "error"
      );

      this.rootStore.generalStore.setShowLoading(false);

      return null;
    }
  };

  public getChangeBoard = async (id: number) => {
    try {
      return await getChangeBoard(id);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter o log da troca de placa.",
        "error"
      );
      return null;
    }
  };

  public getChangeBoards = async (
    limit?: number,
    offset?: number,
    where?: {
      partnerId?: string;
      period?: {
        dateInit?: string | null;
        dateEnd?: string | null;
      };
    }
  ) => {
    try {
      return await getChangeBoards(limit, offset, where);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a lista de trocas de placa.",
        "error"
      );
      return null;
    }
  };
}
